import { ENABLE_JOB_POST_UI_IMPROVEMENT } from '../../constants';

export const defaultTechTestPayload = {
  startTimeLimit: 72,
  duration: 48,
  instruction: {
    subject: 'Case Study Invitation for {Role Name} at {Company Name}',
    message: `
   <p> Hi {Talent Name}, I'm {Your Name} from {Company Name}.</p>
   <p>First of all, congratulations! You're 2 out of 3 steps to become a part of {Company Name} :) </p>
   <p>The next step is we'd like to get to know you better through a case study assessment. You may access the resources for the case study & the countdown to submit the test will automatically run after you confirm by clicking on the confirmation button.</p>
   <p>We wish you the best of luck & we’re looking forward to see your submission :)</p>
    `,
  },
  acceptedSubmissionTypes: ['link', 'document'],
};

export const useGenerateCreateJobUrl = () => {
  const generateCreateJobUrl = () => {
    return ENABLE_JOB_POST_UI_IMPROVEMENT ? '/jobs/create' : '/job-post/create';
  };

  return { generateCreateJobUrl };
};

export const useGenerateEditJobUrl = () => {
  const generateEditJobUrl = (jobId: string) => {
    return ENABLE_JOB_POST_UI_IMPROVEMENT
      ? `/jobs/${jobId}/edit`
      : `/job-post/edit/${jobId}`;
  };

  return { generateEditJobUrl };
};
